

import { useEffect, useLayoutEffect } from 'react';
import { useRef } from 'react'
import { useWindowSize } from '../effects/useWindowSize';
import './SwitchSelector.scss'


// <SwitchSelector active={0}>
//     <SwitchSelectorButton
//         className="btn-sm"
//         active={true}
//         onClick={e => {
//             store.project.updateSinkAmount(1);
//         }}>1 umywalka</SwitchSelectorButton>
//     <SwitchSelectorButton
//         className="btn-sm"
//         active={false}
//         onClick={async e => {
//             // }
//         }}>2 umywalki</SwitchSelectorButton>
// </SwitchSelector>

export default function SwitchSelector({ children, active, disabled = false }) {
    const cont = useRef(null);
    const marker = useRef(null);
    const { width } = useWindowSize();



    useLayoutEffect(() => {

        var activeRect: DOMRect = cont.current.querySelector('.active')?.getBoundingClientRect();
        var contRect: DOMRect = cont.current.getBoundingClientRect();
        console.log({ activeRect, contRect });
        if (activeRect) {

            marker.current.style.left = `${activeRect.left - contRect.left - 1}px`;
            marker.current.style.width = `${activeRect.width}px`;
            console.log({ cont, marker, activeRect });
        }


    });

    var classes = '';
    if (disabled) {
        classes = ' disabled ';
    }

    return <div ref={cont} className={`SwitchSelector ${classes}`}>
        {children}
        <div ref={marker} className="SwitchSelector__marker"></div>
    </div>
}